export default __webpack_public_path__ + "static/media/Megan.b1d42edf.png";